import Div from '@/shared/Div';
import Span from '@/shared/Span';
import { getFormattedPrice } from '@/utils/price';
import classNames from 'classnames';
import { memo, useMemo } from 'react';

export interface PlanPriceProps {
  price: number;
  discountedPrice: number;
  isPlatinum?: boolean;
  expanded?: boolean;
  isActive?: boolean;
  priceClassName?: string;
  className?: string;
  discountedPriceClassName?: string;
}

const PlanPrice: React.FC<PlanPriceProps> = ({
  price,
  discountedPrice,
  expanded,
  isActive,
  priceClassName,
  discountedPriceClassName,
  className,
}) => {
  const formattedPrice = useMemo(() => getFormattedPrice(price), [price]);
  const formattedDiscountedPrice = useMemo(
    () => getFormattedPrice(discountedPrice),
    [discountedPrice],
  );

  const priceJSX = (
    <Span
      className={classNames('text-neutral-700 text-callout-normal font-primary', priceClassName)}
    >
      {formattedPrice}
    </Span>
  );

  if (price === discountedPrice) {
    return priceJSX;
  }

  if (formattedPrice && discountedPrice) {
    return (
      <Div className={classNames('flex flex-col items-end font-primary', className)}>
        <Span
          className={classNames('text-green-500 text-callout-normal', discountedPriceClassName)}
        >
          {formattedDiscountedPrice}
        </Span>
        <Span className={classNames('text-neutral-300 line-through text-sm', priceClassName)}>
          {formattedPrice}
        </Span>
      </Div>
    );
  }

  if (price) {
    return priceJSX;
  }

  return null;
};

export default memo(PlanPrice);
